import styled from "styled-components";

export const FullSizeContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;
